<template>
  <van-tabbar route :active-color="activeColor" :inactive-color="inactiveColor" safe-area-inset-bottom>
    <van-tabbar-item v-for="(item, index) in list" :key="index" :to="item.path" replace >
      <!-- 标题 -->
      <span class="tabbar-title">{{item.title}}</span>
      <!-- 图标 -->
      <template #icon="props">
        <img :src="props.active ? item.iconActive : item.icon" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>

export default {
  name: 'footer-tabbar',
  data() {
    return {
      // 字体颜色 => 选中
      activeColor: '#222222',
      // 字体颜色 => 未选中
      inactiveColor: '#222222',
      // tab列表
      list: [
        {
          title: '首页',
          path: '/index', // 路由
          icon: require('../assets/foot-1.png'),
          iconActive: require('../assets/foot-1active.png'),
        },{
          title: '论坛',
          path: '/forum', // 路由
          icon: require('../assets/foot-2.png'),
          iconActive: require('../assets/foot-2active.png'),
        },{
          title: '热搜',
          path: '/hot-search', // 路由
          icon: require('../assets/foot-3.png'),
          iconActive: require('../assets/foot-3active.png'),
        },
        {
          title: '我的',
          path: '/my', // 路由
          icon: require('../assets/foot-4.png'),
          iconActive: require('../assets/foot-4active.png'),
        },
      ],
    };
  }
}
</script>

<style scoped>
.van-tabbar{
  height: 50px;
}
.tabbar-title{
  font-size: 10px;
}
</style>
